import React, { memo, useEffect } from "react"
import PropTypes from "prop-types"
import { useDispatch } from "react-redux"
import { Card, Radio, Typography, Space, Image } from "antd"
import { setSelectedCardLast4, setSelectedPaymentMethodId } from "store/user"
import { brandImage } from "components/bookings/helpers"
import styles from "./BookingForm.module.css"

const { Text } = Typography

const PaymentMethodList = ({ active, paymentMethods, className, setActive }) => {
  const dispatch = useDispatch()
  const hasPaymentMethods = !!paymentMethods?.length

  useEffect(() => {
    if (active && paymentMethods?.length) {
      dispatch(setSelectedPaymentMethodId(active))
      const selectedCard = paymentMethods.find((card) => card.payment_method_id === active)
      if (selectedCard) {
        dispatch(setSelectedCardLast4(selectedCard.last4))
      }
    }
  }, [active, paymentMethods, dispatch])

  const handleCardChange = (e) => {
    dispatch(setSelectedPaymentMethodId(e.target?.value))
    setActive(e.target?.value)
    const selectedCard = paymentMethods?.find((card) => card?.payment_method_id === e.target?.value)
    if (selectedCard) {
      dispatch(setSelectedCardLast4(selectedCard?.last4))
    }
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <Radio.Group value={active} onChange={handleCardChange} className={styles.radioGroup}>
        <Space direction="vertical" className={styles.spaceContainer}>
          {hasPaymentMethods &&
            paymentMethods?.map((card) => (
              <Card
                key={card?.payment_method_id}
                className={active === card?.payment_method_id ? styles.cardActive : styles.card}
              >
                <div className={styles.cardContent}>
                  <Space align="center">
                    <Radio value={card?.payment_method_id} />
                    <Image
                      src={brandImage(card?.brand)}
                      className={styles.cardImage}
                      preview={false}
                      alt={card?.brand}
                    />
                    <div className={styles.cardInfo}>
                      <div className={styles.cardDetails}>
                        <Text strong className={styles.brandName}>
                          {card?.brand.charAt(0).toUpperCase() + card?.brand.slice(1)}
                        </Text>
                        <Text className={styles.cardNumber}>****{card?.last4}</Text>
                        <Text className={styles.expiryDate}>
                          Expires {card?.exp_month.toString().padStart(2, "0")}/{card?.exp_year.toString().slice(-2)}
                        </Text>
                      </div>
                    </div>
                  </Space>
                </div>
              </Card>
            ))}
        </Space>
      </Radio.Group>
    </div>
  )
}

PaymentMethodList.propTypes = {
  active: PropTypes.string.isRequired,
  paymentMethods: PropTypes.array,
  className: PropTypes.string,
  setActive: PropTypes.func,
}

export default memo(PaymentMethodList)
